// 固件升级
const state = {
    // 固件升级按钮是否显示
    visibleFirmwareUpgradeBtn: false,
    // 固件升级弹窗是否显示
    visibleFirmwareUpgrade: false,
    // 升级状态
    upgradeStatus: '',
    // 升级提示
    visibleWarningTip: false,
}

const mutations = {
    setState(state, payload) {
        state[payload.key] = payload.value
    },
}

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
